export default  {
  bindings: {
    availability: '=',
    categories: '<',
    events: '<',
    type: '<'
  },
  controller: 'availabilityFormController',
  template: require('../views/availability.form.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/availability/components/availability.form.component.js